import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase/firebaseConfig";
import RenameAlbum from "./RenameAlbum";
import { LinearProgress } from '@material-ui/core';
import "../styles/ImageGrid.css";
import { AuthContext } from '../context/AuthContext';

const ImageGrid = ({ setImage }) => {
  const { albumId } = useParams();
  const { currentUser } = useContext(AuthContext);
  const[loading, setLoading] = useState(false);
  const [albumArray, setAlbumArray] = useState([]);
  const [albumName, setAlbumName] = useState("");
  const collectionRef = db.collection(currentUser?.email).doc(currentUser?.uid).collection("albums");
  
 
  useEffect(() => {
    console.log("ImageGrid");
    const unsub = collectionRef
      .doc(albumId)
      .onSnapshot((snapshot) => {
        console.log(snapshot.data());
        setAlbumArray(snapshot.data().images);
        setLoading(true);
      });
      collectionRef
      .doc(albumId)
      .get()
      .then((doc) => {
        setAlbumName(doc.data()?.albumName);
      });

    return () => unsub();
  }, [albumId,]);

  console.log(albumArray);
  var sortedArray = [];
  if (albumArray.length > 1) {
    sortedArray = albumArray.sort(function (b, a) {
      return a.index - b.index;
    });
    console.log(sortedArray);
  } else {
    sortedArray = albumArray;
  }

  return (
    <div className="img__grid__parent">
      <RenameAlbum
      setLoading={setLoading}
        albumId={albumId}
        setAlbumName={setAlbumName}
        sortedArray={sortedArray}
        albumName={albumName}
      />
      <h2>{albumName} album</h2>
      <div className="img-grid">
        {loading?sortedArray.map((doc) => (
            <div
              key={doc.createdAt}
              className="img-wrap"
              onClick={() => setImage(doc)}
            >
              <img src={doc.url} alt={doc.name} />
            </div>
          )): <div style={{margin:"1rem" }}><LinearProgress style={{marginTop:"1rem"}}/> </div>   }
          
      </div>
    </div>
  );
};

export default ImageGrid;
